export default "/fonts/SegoeUI.woff?109f32860bdef32b32d4c4dac14876ac";